import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters('resultMessage', [ 'resultMessage' ])
  },
  watch: {
  },
  asyncComputed: {
    roleList: {
      lazy: true,
      get: function () {
        return this.$tango.searchUserRole().then(rep => rep.roleList.filter(r => r.status === 1))
      },
      default: []
    }
  },
  methods: {
    handleDelete: function (cond) {
      this.$confirm('This will permanently delete the user. Continue ?', 'Warning', {
        confirmButtonText: this.$t('OK'),
        cancelButtonText: this.$t('Cancel'),
        type: 'warning'
      }).then(() => {
        this.$tango.deleteUser({ userList: cond }).then(rep => {
          if (rep.resultCode !== 0) {
            throw new Error(this.$t('Deleted failed') + ' ' + this.$t(this.resultMessage[rep.resultCode]))
          }
          else {
            this.$message({
              type: 'success',
              message: this.$t('Deleted successfully')
            })
            for(let item in cond) {
              let route = {
                path: '/admin/user/edit',
                params: { recordId: item.userId },
                meta: { title: this.$route.meta.title }
              }
              this.$store.dispatch('tagsView/delView', route)
            }
            this.$router.push({ path: '/next' }).then(() => { return this.$router.push({ name: 'adminUserList' }) }).catch(() => {})
          }
        }).catch(err => {
          // eslint-disable-next-line no-console
          console.log(err)
          this.$message({
            type: 'error',
            message: err.message
          })
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Delete canceled'
        })
      })
    },
    regenerateAccountCode: function (email) {
      this.$tango.regenerateAccountCode(email).then(rep => {
        if (rep.resultCode === 8) {
          throw new Error('Error regenerate activation code')
        }
        else {
          this.$message({
            type: 'success',
            message: this.$t('Regenerate code request has been completed successfully')
          })
        }
      }).catch(err => {
        // eslint-disable-next-line no-console
        console.log(err)
        this.message = this.$t('Error: technical ')
        this.$message({
          type: 'error',
          message: err.message
        })
      })
    }
  }
}
